module.exports = __webpack_public_path__ + "img/KZ.209e7ddd.png";